import { render } from "./country-delete.vue?vue&type=template&id=f59dc6a2"
import script from "./country-delete.vue?vue&type=script&lang=js"
export * from "./country-delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__